import React, { Fragment } from "react";

import { Box, Hidden, Tab, Tabs } from "@material-ui/core";
import { PlusCircle } from "react-feather";

import { AreaCard, MobileAddButton } from "@hubcapp/components";
import { FranchiseType } from "@hubcapp/types";
import Button from "@ds-developer/button";
import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";

import { AreaFilterTabItem, AreasCoveredProps } from "./types";

const AreasCovered: React.FC<AreasCoveredProps> = ({
  onTabChange,
  franchise,
  handleNewAreaClick,
  loading,
  filterTabItems,
}) => (
  <Content>
    <PageHeader
      title="My areas covered"
      breadcrumbs={[
        {
          title: "Home",
          link: "/",
        },
        {
          title: "Areas & prices",
        },
      ]}
      actionButton={
        franchise &&
        franchise?.proposition?.type &&
        franchise?.proposition?.type !== FranchiseType.Dit && (
          <Fragment>
            <Hidden smUp>
              <MobileAddButton
                data-test="add-new-area-button"
                onClick={handleNewAreaClick}
              />
            </Hidden>
            <Hidden xsDown>
              <Button
                data-test="add-new-area-button"
                color="secondary"
                startIcon={<PlusCircle size={14} />}
                variant="contained"
                onClick={handleNewAreaClick}
              >
                Add a new area
              </Button>
            </Hidden>
          </Fragment>
        )
      }
    />
    {franchise && filterTabItems && filterTabItems.length > 1 && (
      <Tabs
        indicatorColor="secondary"
        onChange={onTabChange}
        textColor="secondary"
        value={franchise.id}
        variant="scrollable"
      >
        {filterTabItems.map((filterTabItem: AreaFilterTabItem) => (
          <Tab {...filterTabItem} key={filterTabItem.key} />
        ))}
      </Tabs>
    )}
    <Box mt={3}>
      <AreaCard franchise={franchise} loading={loading} />
    </Box>
  </Content>
);
export default AreasCovered;
